// src/components/TextType.js
import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

const TextType = ({
  text = "REVERSITE",
  typingSpeed = 120,
  deletingSpeed = 60,
  pauseDuration = 3000,
  loop = true,
  showCursor = true,
  cursorCharacter = "|",
  className = "",
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const cursorRef = useRef(null);

  useEffect(() => {
    let timer;

    const type = () => {
      if (!isDeleting && displayedText.length < text.length) {
        timer = setTimeout(() => {
          setDisplayedText(text.substring(0, displayedText.length + 1));
        }, typingSpeed);
      } else if (isDeleting && displayedText.length > 0) {
        timer = setTimeout(() => {
          setDisplayedText(text.substring(0, displayedText.length - 1));
        }, deletingSpeed);
      } else if (!isDeleting && displayedText.length === text.length) {
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, pauseDuration);
      } else if (isDeleting && displayedText.length === 0 && loop) {
        timer = setTimeout(() => {
          setIsDeleting(false);
        }, 500);
      }
    };

    type();

    // Мигание курсора
    if (showCursor && cursorRef.current) {
      gsap.to(cursorRef.current, {
        opacity: 0,
        duration: 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'none'
      });
    }

    return () => clearTimeout(timer);
  }, [displayedText, isDeleting, text, typingSpeed, deletingSpeed, pauseDuration, loop, showCursor]);

  return (
    <span className={className} style={{ color: 'white' }}>
      {displayedText}
      {showCursor && (
        <span ref={cursorRef} style={{ color: 'white', fontWeight: 'bold', marginLeft: '2px' }}>
          {cursorCharacter}
        </span>
      )}
    </span>
  );
};

export default TextType;